import React, { useState, useContext } from "react";
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import CircularProgress from '@material-ui/core/CircularProgress';

const LoadingDialog = (props) => {
  const { children } = props;
  return <Dialog open>
        <DialogTitle>
          <CircularProgress size={18}/> {children}
        </DialogTitle>
      </Dialog>
}

export default LoadingDialog